import React from 'react';
import { TouchableOpacity, Image, StyleSheet } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import theme from '../../constants/theme.style.js';

const image = require('../../assets/icons/newmessage/image.png');

const styles = StyleSheet.create({
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
    margin: 15,
  },
});

export default class CameraComponent extends React.Component {
  pickImage = async () => {
    // console.info('picking image'); // this was used for the test in Camera.test.web.js
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsMultipleSelection: false,
      // allowsEditing: true,
      // aspect: [4, 3],
      quality: 1,
    });

    if (!result.cancelled) {
      const { parentCallback } = this.props;
      parentCallback(result.uri);
    }
  };

  render() {
    return (
      <TouchableOpacity
        testID="pickImageButton"
        style={styles.imagePickerButton}
        onPress={this.pickImage}
      >
        <Image testID="pickImageIcon" source={image} style={styles.icon} />
      </TouchableOpacity>
    );
  }
}
